import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  PutDocumentsQueueGroupsRequestType,
  PutDocumentsQueueGroupsResponseType,
} from '../types';

export const putDocumentsQueueGroups = async (
  params: PutDocumentsQueueGroupsRequestType,
) => {
  const url = `/api/v2/documents/${params.documentId}/queue/groups`;
  const response = await apiAuthClient.put<PutDocumentsQueueGroupsResponseType>(
    url,
    {
      groups: params.groups,
    },
  );

  return response.data;
};
